import { useQuery, useMutation } from 'react-query';
import { request } from '../utility/axios-utils';
import useAxiosPrivate from '../hooks/useAxiosPrivate';

const serviceData = (url) => {
  return request({
    url: '/settings/getservices?url=' + url,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
export const useServiceData = (url) => {
  return useQuery('servicedetails', () => serviceData(url), {
    enabled: true,
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });
};
const register = (data) => {
  return request({
    url: '/register',
    method: 'post',
    data,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });
};
export const useHandleSignup = (onSuccess, onError) => {
  return useMutation('register', register, {
    onSuccess,
    onError,
    enabled: false,
    refetchOnWindowFocus: true,
    cacheTime: 0,
  });
};
const login = (data) => {
  return request({
    url: '/login',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' },
  });
};
export const useLogin = (onSuccess, onError) => {
  return useMutation('login', login, {
    onSuccess,
    onError,
    enabled: false,
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });
};

const loginService = (data) => {
  return request({
    url: '/login/loginService',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' },
  });
};
export const useLoginService = (onSuccess, onError) => {
  return useMutation('loginService', loginService, {
    onSuccess,
    onError,
    enabled: false,
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });
};

const resendOTP = (data) => {
  return request({
    url: '/resendOTP',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' },
  });
};
export const useResendOTP = (onError) => {
  return useMutation('resendOTP', resendOTP, {
    onError,
    enabled: false,
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });
};

export const useVerifyMobile = (onSuccess, onError) => {
  const axiosPrivate = useAxiosPrivate();
  return useMutation(
    'verifymobile',
    (verifymobile) => {
      return axiosPrivate.post('/verifymobile', verifymobile);
    },
    {
      onSuccess,
      onError,
      enabled: false,
      cacheTime: 0,
    },
  );
};
export const useVerifyEmail = (onSuccess, onError) => {
  const axiosPrivate = useAxiosPrivate();
  return useMutation(
    'verifyemail',
    (verifyemail) => {
      return axiosPrivate.post('/verifyemail', verifyemail);
    },
    {
      onSuccess,
      onError,
      enabled: false,
      cacheTime: 0,
    },
  );
};
export const useVerifyEmailOTP = (onSuccess, onError) => {
  const axiosPrivate = useAxiosPrivate();
  return useMutation(
    'verifyemailotp',
    (verifyemailotp) => {
      return axiosPrivate.post('/verifyemailotp', verifyemailotp);
    },
    {
      onSuccess,
      onError,
      enabled: false,
      cacheTime: 0,
    },
  );
};
const verifyloginotp = (data) => {
  return request({
    url: '/verifyloginotp',
    method: 'post',
    data,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });
};
export const useVerifyLoginOTP = (onSuccess, onError) => {
  return useMutation('verifyloginotp', verifyloginotp, {
    onSuccess,
    onError,
    enabled: false,
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });
};

export const useVerifyMobileOTP = (onSuccess, onError) => {
  const axiosPrivate = useAxiosPrivate();
  return useMutation(
    'verifymobileotp',
    (verifymobileotp) => {
      return axiosPrivate.post('/verifymobileotp', verifymobileotp);
    },
    {
      onSuccess,
      onError,
      enabled: false,
      cacheTime: 0,
    },
  );
};
export const useUpdateEmail = (onSuccess, onError) => {
  const axiosPrivate = useAxiosPrivate();
  return useMutation(
    'updateemail',
    (updateemail) => {
      return axiosPrivate.post('/updateemail', updateemail);
    },
    {
      onSuccess,
      onError,
      enabled: false,
      cacheTime: 0,
    },
  );
};
export const useUpdateMobile = (onSuccess, onError) => {
  const axiosPrivate = useAxiosPrivate();
  return useMutation(
    'updatemobile',
    (updatemobile) => {
      return axiosPrivate.post('/updatemobile', updatemobile);
    },
    {
      onSuccess,
      onError,
      enabled: false,
      cacheTime: 0,
    },
  );
};
const updateConsent = (data) => {
  return request({
    url: '/consent',
    method: 'post',
    data,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });
};
export const useConsentStatus = (enabled, onSuccess, onError) => {
  return useMutation('consent', updateConsent, {
    enabled,
    onSuccess,
    onError,
    refetchOnWindowFocus: true,
    cacheTime: 0,
  });
};

const approveTransactionApi = (stagingId) => {
  return request({
    url: `/transaction/validate-and-proceed/${stagingId}`,
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
  });
};
export const useApproveTransaction = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (stagingId) => approveTransactionApi(stagingId),
    onSuccess,
    onError,
  });
};
